export default "__VITE_ASSET__C22ucEOx__"